import { derivePersona, type PersonaKey } from '@/shared/domain'
import { useOrgContext } from './use-org-context'

export function useCurrentPersona(): { persona: PersonaKey; isLoading: boolean } {
  const ctx = useOrgContext()
  return { persona: derivePersona(ctx.orgType, ctx.role), isLoading: ctx.isLoading }
}
